import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '@interfaces/user';
import { AuthService } from '@services/auth.service';
import { CommonApiService } from '@services/common-apis.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss']
})
export class ChatbotComponent implements OnInit, OnDestroy {

  private readonly chatbotUsername = 'TCSBotUser';
  private readonly chatbotPassword = 'TCSBotPassword123!';
  private sub!: Subscription;
  username: string = '';
  sessionName: string = '';
  baseUrl = '';
  messages: any[] = [];
  isOpen = false;
  question = '';
  sessionStarted = false;
  showHelpBubble: boolean = false;
  loading: boolean = false;
  token: string = '';
  user: User | null;


  @ViewChild('scrollMe') private chatContainer!: ElementRef;


  constructor(
    private httpext: HttpClient,
    private router: Router,
    private auth: AuthService,
    private commonApi: CommonApiService
  ) {
    this.user = this.auth.currentUserValue;
  }

  ngOnInit(): void {

    this.sub = this.commonApi.toggleChat$.subscribe(() => {
      this.toggleChat();
    });

    const user = this.auth.currentUserValue;
    if (user && user.UserID) {
      this.username = user.UserID;
    }

    if (user?.TCFormat) {
      switch (user.TCFormat) {
        case 'JDT':
          this.baseUrl = 'https://chatbot.meshilogic.com/JDTTCS';
          break;
          case 'Demo':
          this.baseUrl = 'https://chatbot.meshilogic.com/demotcs';
          break;
        default:
          this.baseUrl = 'https://chatbot.meshilogic.com/TCS';
          break;
      }
    }

    console.log('this.baseUrl:', this.baseUrl);




    if (!this.isOpen) {
      setTimeout(() => {
        this.showHelpBubble = true;
      }, 1000);
    }

  }



  ngOnDestroy() {
    this.sub.unsubscribe();
  }



  loginAndStartSession(): void {
    // this.loading = true;

    const loginData = {
      username: this.chatbotUsername,
      password: this.chatbotPassword
    };

    this.httpext.post(this.baseUrl + '/login', loginData).subscribe({
      next: (response: any) => {
        // this.loading = false;
        this.token = response.access_token;
        console.log('Login successful, token received:', this.token);

        this.startSession();
        // Decode the JWT token to see its contents
        try {
          const payload = JSON.parse(atob(this.token.split('.')[1]));
          console.log('JWT Payload:', payload);
        } catch (e) {
          console.error('Failed to decode JWT:', e);
        }


      },
      error: (error) => {
        // this.loading = false;
        console.error('Login failed:', error);
        this.messages.push({ sender: 'bot', text: '❌ Failed to authenticate with chatbot service.' });
      }
    });
  }





  async toggleChat(): Promise<void> {
    this.isOpen = !this.isOpen;

    setTimeout(() => {
      this.scrollToBottom();
    }, 200);

    if (this.isOpen) {
      this.showHelpBubble = false;

      const user = this.auth.currentUserValue;

      if (user && user.UserID) {
        this.username = user.UserID;

        // Always generate a new session name
        this.sessionName = (user.TCFormat ?? 'session_') + '_' + Date.now();
        this.sessionStarted = false;

        // First login, then start session
        this.loginAndStartSession();

      } else {
        this.messages.push({ sender: 'bot', text: '❌ Cannot start session. User not found.' });
      }

    } else {
      this.messages = [];
      this.sessionStarted = false;
      setTimeout(() => {
        this.showHelpBubble = true;
      }, 1000);
    }
  }



  closeChat() {
    this.isOpen = false;
    this.endSession();
  }





  startSession() {
    // let headers = new HttpHeaders();
    // if (this.accessToken) {
    // headers = headers.set('Authorization', `Bearer ${accessToken}`);
    // console.log("Headers:",headers);

    // }
    // console.log("check here");

    let headersCB = new HttpHeaders();
    headersCB = headersCB.set('Authorization', `Bearer ${this.token}`); // No Bearer
    headersCB = headersCB.set('Content-Type', 'application/json');


    this.httpext.post(this.baseUrl + '/start_session', {
      username: this.chatbotUsername,
      session_name: this.sessionName
    }, { headers: headersCB }).subscribe({
      next: (response: any) => {
        this.sessionStarted = true;
        // if (response.message === "Session created") {
        //   this.messages.push({ sender: 'bot', text: 'Hello! How can I help you today?' });
        // } else {
        //   this.messages.push({ sender: 'bot', text: 'Session started successfully!' });
        // }
      },
      error: (error) => {
        console.error('Start session error:', error);
        this.messages.push({ sender: 'bot', text: '❌ Failed to start chat session.' });
      }
    });
  }



  sendMessage(): void {
    const question = this.question.trim();
    if (!question || !this.sessionStarted) return;

    this.messages.push({ sender: 'user', text: question });
    this.scrollToBottom();
    this.question = '';
    this.loading = true;

    let headers = new HttpHeaders();
    // if (this.token) {
    headers = headers.set('Authorization', `Bearer ${this.token}`);
    headers = headers.set('Content-Type', 'application/json');
    // }

    this.httpext.post(this.baseUrl + '/ask', {
      username: this.chatbotUsername,
      session_name: this.sessionName,
      question: question,
      model: "gemini"
    }, { headers }).subscribe({
      next: (response: any) => {
        this.loading = false;
        this.messages.push({ sender: 'bot', text: response.response || 'No response.' });
        this.scrollToBottom();
      },
      error: (error) => {
        this.loading = false;
        console.error('Ask error details:', error);
        this.messages.push({ sender: 'bot', text: '❌ Error talking to the bot.' });
        this.scrollToBottom();
      }
    });
  }



  scrollToBottom(): void {
    try {
      setTimeout(() => {
        this.chatContainer.nativeElement.scroll({
          top: this.chatContainer.nativeElement.scrollHeight,
          behavior: 'smooth'
        });
      }, 100); // slight delay to wait for DOM update
    } catch (err) {
      console.error('Scroll error:', err);
    }
  }




  endSession(): void {
    let headers = new HttpHeaders();
    // if (this.token) {
    headers = headers.set('Authorization', `Bearer ${this.token}`);
    headers = headers.set('Content-Type', 'application/json');
    // }

    this.httpext.post(this.baseUrl + '/end_session', {
      username: this.chatbotUsername,
      session_name: this.sessionName
    }, { headers }).subscribe();
     // Clear the chat history
    this.messages = [];
  }



  shouldHide(): boolean {
    return !this.auth.isLoggedIn || this.router.url === '/login';
  }



}